"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
function cov_l9pjed02u() {
  var path = "/codebuild/output/src3154135081/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Tabs/lib/uuid.js";
  var hash = "a0b3f51ecb62b5833a232d1200e6224079df467a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3154135081/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Tabs/lib/uuid.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 13
        },
        end: {
          line: 1,
          column: 14
        }
      },
      "1": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 4,
          column: 14
        }
      },
      "2": {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 5,
          column: 31
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 15
          },
          end: {
            line: 3,
            column: 16
          }
        },
        loc: {
          start: {
            line: 3,
            column: 41
          },
          end: {
            line: 6,
            column: 1
          }
        },
        line: 3
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 3,
            column: 24
          },
          end: {
            line: 3,
            column: 39
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 3,
            column: 33
          },
          end: {
            line: 3,
            column: 39
          }
        }],
        line: 3
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a0b3f51ecb62b5833a232d1200e6224079df467a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_l9pjed02u = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_l9pjed02u();
var lastId = (cov_l9pjed02u().s[0]++, 0);
function _default() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_l9pjed02u().b[0][0]++, 'uuid');
  cov_l9pjed02u().f[0]++;
  cov_l9pjed02u().s[1]++;
  lastId += 1;
  cov_l9pjed02u().s[2]++;
  return "".concat(prefix, "-").concat(lastId);
}